let config = require('./config.global');

config.env = 'production';
config.hostname = 'localhost';

module.exports = config;
